"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-item.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-item.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityItem = void 0;
const amount_1 = require("../common/amount");
const transaction_1 = require("../ledger/transaction");
const transaction_error_code_1 = require("../ledger/transaction-error-code");
const transaction_limit_error_1 = require("../ledger/transaction-limit-error");
const activity_context_1 = require("./activity-context");
const activity_status_1 = require("./activity-status");
const activity_tag_1 = require("./activity-tag");
const protobufPackage = 'com.step.txactivity.proto';
function createBaseActivityItem() {
    return {
        id: '',
        accountId: '',
        paymentId: '',
        primaryAccountId: '',
        userId: '',
        description: '',
        amount: amount_1.Amount.fromPartial({}),
        iconUrl: '',
        createdAtMs: '0',
        context: activity_context_1.ActivityContext.fromPartial({}),
        status: activity_status_1.ActivityStatus.INVALID_ACTIVITY_STATUS,
        category: undefined,
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        limitError: undefined,
        associated: [],
        tags: [],
    };
}
exports.ActivityItem = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            context: isSet(object.context)
                ? activity_context_1.ActivityContext.fromJSON(object.context)
                : activity_context_1.ActivityContext.fromPartial({}),
            status: isSet(object.status)
                ? (0, activity_status_1.activityStatusFromJSON)(object.status)
                : activity_status_1.ActivityStatus.INVALID_ACTIVITY_STATUS,
            tags: globalThis.Array.isArray(object?.tags)
                ? object.tags.map((e) => (0, activity_tag_1.tagFromJSON)(e))
                : [],
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.iconUrl)) {
            message.iconUrl = globalThis.String(object.iconUrl);
        }
        if (isSet(object.category)) {
            message.category = transaction_1.TransactionCategory.fromJSON(object.category);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.limitError)) {
            message.limitError = transaction_limit_error_1.TransactionLimitError.fromJSON(object.limitError);
        }
        if (globalThis.Array.isArray(object?.associated)) {
            message.associated = object.associated.map((e) => exports.ActivityItem.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.iconUrl !== undefined && message.iconUrl !== '') {
            obj.iconUrl = message.iconUrl;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.context !== undefined) {
            obj.context = activity_context_1.ActivityContext.toJSON(message.context);
        }
        if (message.status !== activity_status_1.ActivityStatus.INVALID_ACTIVITY_STATUS) {
            obj.status = (0, activity_status_1.activityStatusToJSON)(message.status);
        }
        if (message.category !== undefined) {
            obj.category = transaction_1.TransactionCategory.toJSON(message.category);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.limitError !== undefined) {
            obj.limitError = transaction_limit_error_1.TransactionLimitError.toJSON(message.limitError);
        }
        if (message.associated?.length) {
            obj.associated = message.associated.map((e) => exports.ActivityItem.toJSON(e));
        }
        if (message.tags?.length) {
            obj.tags = message.tags.map((e) => (0, activity_tag_1.tagToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.ActivityItem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityItem();
        message.id = object.id ?? '';
        message.accountId = object.accountId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.userId = object.userId ?? '';
        message.description = object.description ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.iconUrl = object.iconUrl ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.context = (object.context !== undefined && object.context !== null)
            ? activity_context_1.ActivityContext.fromPartial(object.context)
            : activity_context_1.ActivityContext.fromPartial({});
        message.status = object.status ?? activity_status_1.ActivityStatus.INVALID_ACTIVITY_STATUS;
        message.category = (object.category !== undefined && object.category !== null)
            ? transaction_1.TransactionCategory.fromPartial(object.category)
            : undefined;
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.limitError = (object.limitError !== undefined && object.limitError !== null)
            ? transaction_limit_error_1.TransactionLimitError.fromPartial(object.limitError)
            : undefined;
        message.associated = object.associated?.map((e) => exports.ActivityItem.fromPartial(e)) || [];
        message.tags = object.tags?.map((e) => e) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-item.js.map